module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"hide":"Свернуть","show":"Развернуть"},"en":{"hide":"Hide","show":"Show"}}')
  delete Component.options._Ctor
}
